import React from 'react'
import { useTranslations } from 'next-intl'
import Paragraph from '@/shared/v2/shared/components/Paragraph'
import ImportField from './ImportField'

interface ImportMetaFieldsProps {
    status: React.ReactNode
    workflowLabel: string
    importDate: string
}

const ImportMetaFields = ({ status, workflowLabel, importDate }: ImportMetaFieldsProps) => {
    const t = useTranslations('imports')

    return (
        <div className="grid grid-cols-1 gap-4">
            <ImportField label={t('detail.fields.status')}>{status}</ImportField>
            <ImportField label={t('detail.fields.workflow')}>
                <Paragraph>{workflowLabel}</Paragraph>
            </ImportField>
            <ImportField label={t('detail.fields.importDate')}>
                <Paragraph>{importDate}</Paragraph>
            </ImportField>
        </div>
    )
}

export default ImportMetaFields
